import { PropertiesWithProject } from "@eres/ejari-api/Entity/LeasedProperties";
import React, { Component } from "react";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { getDevName, getProjectName, getProjectNo, getPropertyCount, ProjectProps } from "./ProjectListView";
import Strings from "@my-dld/assets/strings";

interface State {
	page: number;
}

class ProjectGridView extends Component<ProjectProps, State> {
	constructor( props: ProjectProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { projects, onProjectSelect } = this.props;
		return <GridDataView
			items={ this.getPageData() }
			renderGridItem={ ( item: PropertiesWithProject ) => {
				return <RenderGridItem
					key={ "prop_with_projects_grid_" + item.ProjectId }
					project={ item }
					onDetails={ onProjectSelect }/>;
			} }
			totalCount={ projects.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getPageData() {
		const { projects } = this.props;
		const { page } = this.state;
		return projects.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: { project: PropertiesWithProject, onDetails: ( project: PropertiesWithProject ) => void } ) {
	const { project, onDetails } = props;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
        <div className="card">
            <div className="custom-card-title">
                <div>
                    <span>{getProjectName(project)}</span>
                    <span>{Strings.Project_Name_Label}</span>
                </div>
            </div>
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ getProjectNo( project ) }</span>
							<span>{ Strings.project_number }</span>
						</div>
						<div className="col-6">
							<span>{ getPropertyCount( project ) }</span>
							<span>{ Strings.no_of_properties }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-12">
							<span>{ getDevName( project ) }</span>
							<span>{ Strings.developer_name }</span>
						</div>
					</div>
				</div>
            </div>
            <div className="property-card-action">
                <button
                    className="btn btn_1_outline"
                    onClick={() => onDetails(project)}>{Strings.view_details}</button>
            </div>
		</div>
	</div>;
}

export default ProjectGridView;
